import { Box } from "@mui/material";
import { useEffect, useRef } from "react";

interface LiveRegionProps {
  message: string;
  priority?: "polite" | "assertive" | "off";
  id?: string;
}

/**
 * Live region component for screen reader announcements
 * Use for dynamic content updates that need to be announced
 */
export const LiveRegion = ({
  message,
  priority = "polite",
  id = "live-region",
}: LiveRegionProps) => {
  const regionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (message && regionRef.current) {
      // Force screen reader to announce the message
      const region = regionRef.current;
      region.setAttribute("aria-live", priority);
      region.setAttribute("aria-atomic", "true");
    }
  }, [message, priority]);

  return (
    <Box
      ref={regionRef}
      id={id}
      component="div"
      aria-live={priority}
      aria-atomic="true"
      sx={{
        position: "absolute",
        left: "-10000px",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      {message}
    </Box>
  );
};




